import React from 'react';
import {Avatar, Box, Button, Chip, TableCell, TableRow} from "@mui/material";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Grid from "@mui/material/Grid2";
import Constants from "../../../../utils/constants";
import AgenceBadge from "../../agences/AgenceBadge";

function ClientRow({client, onEdit, onDelete, canDelete}) {
    return (
        <TableRow hover onClick={() => onEdit("client", client.id)} style={{cursor: 'pointer'}}>
            <TableCell>
                <AgenceBadge agence={client.agence}/>
            </TableCell>
            <TableCell component="th">
                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                    <Avatar src={Constants.API_ASSETS_USER_LOGO + client.logo?.contentUrl} sx={{width: 28, height: 28}}/>
                    {client.libelle}
                </Box>
            </TableCell>
            <TableCell>{client.email}</TableCell>
            <TableCell>
                {client.typologieConteneurs && client.typologieConteneurs.map((type, index) => (
                    <Chip size={'small'} label={type} key={index} sx={{marginRight: "1rem"}}/>
                ))}
            </TableCell>
            <TableCell>
                {client.isAccredited
                    ? <Button size="small" disabled className="toggle-button-small button-selected-green">Oui</Button>
                    : <Button size="small" disabled className="toggle-button-small button-selected-red">Non</Button>}
            </TableCell>
            <TableCell>
                <Grid container justify={"flex-end"} spacing={2}>
                    <Grid item>
                        <Button color="secondary" size="small"
                                onClick={(e) => { e.stopPropagation(); onEdit("client", client.id); }}
                                startIcon={<ModeEditOutlineOutlinedIcon/>}>
                            Editer
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button color="error" size="small"
                                disabled={!canDelete(client)}
                                onClick={(e) => { e.stopPropagation(); onDelete(client); }}
                                startIcon={<CloseOutlinedIcon/>}>
                            Supprimer
                        </Button>
                    </Grid>
                </Grid>
            </TableCell>
        </TableRow>
    );
}

export default ClientRow;
